@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(1_151_430_244)
internal val Res.string.companies_form_add_title: StringResource by lazy {
      StringResource("string:companies_form_add_title", "companies_form_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12443, 56),
      ))
    }

@delegate:ResourceContentHash(-1_384_119_144)
internal val Res.string.companies_form_edit_title: StringResource by lazy {
      StringResource("string:companies_form_edit_title", "companies_form_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12500, 53),
      ))
    }

@delegate:ResourceContentHash(148_263_877)
internal val Res.string.companies_go_to_org_chart: StringResource by lazy {
      StringResource("string:companies_go_to_org_chart", "companies_go_to_org_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12554, 61),
      ))
    }

@delegate:ResourceContentHash(-497_212_331)
internal val Res.string.companies_inactive: StringResource by lazy {
      StringResource("string:companies_inactive", "companies_inactive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12616, 38),
      ))
    }

@delegate:ResourceContentHash(147_729_918)
internal val Res.string.companies_invalid_number: StringResource by lazy {
      StringResource("string:companies_invalid_number", "companies_invalid_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12655, 80),
      ))
    }

@delegate:ResourceContentHash(-801_140_368)
internal val Res.string.companies_invalid_percent: StringResource by lazy {
      StringResource("string:companies_invalid_percent", "companies_invalid_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12736, 117),
      ))
    }

@delegate:ResourceContentHash(735_093_790)
internal val Res.string.companies_management_hint: StringResource by lazy {
      StringResource("string:companies_management_hint", "companies_management_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12854, 125),
      ))
    }

@delegate:ResourceContentHash(127_127_642)
internal val Res.string.companies_more_names: StringResource by lazy {
      StringResource("string:companies_more_names", "companies_more_names", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12980, 36),
      ))
    }

@delegate:ResourceContentHash(893_954_141)
internal val Res.string.companies_none: StringResource by lazy {
      StringResource("string:companies_none", "companies_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13017, 30),
      ))
    }

@delegate:ResourceContentHash(-48_404_385)
internal val Res.string.companies_only_active: StringResource by lazy {
      StringResource("string:companies_only_active", "companies_only_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13048, 49),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.companies_retry: StringResource by lazy {
      StringResource("string:companies_retry", "companies_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13098, 47),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.companies_save: StringResource by lazy {
      StringResource("string:companies_save", "companies_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13146, 30),
      ))
    }

@delegate:ResourceContentHash(777_309_623)
internal val Res.string.companies_search_placeholder: StringResource by lazy {
      StringResource("string:companies_search_placeholder", "companies_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13177, 92),
      ))
    }

@delegate:ResourceContentHash(176_430_324)
internal val Res.string.companies_service_add: StringResource by lazy {
      StringResource("string:companies_service_add", "companies_service_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13270, 53),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.companies_service_cancel: StringResource by lazy {
      StringResource("string:companies_service_cancel", "companies_service_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13324, 44),
      ))
    }

@delegate:ResourceContentHash(-1_046_995_820)
internal val Res.string.companies_service_daily_quantity: StringResource by lazy {
      StringResource("string:companies_service_daily_quantity", "companies_service_daily_quantity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13369, 64),
      ))
    }

@delegate:ResourceContentHash(-1_098_961_822)
internal val Res.string.companies_service_delete: StringResource by lazy {
      StringResource("string:companies_service_delete", "companies_service_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13499, 56),
      ))
    }

@delegate:ResourceContentHash(-1_098_961_822)
internal val Res.string.companies_service_delete_confirm: StringResource by lazy {
      StringResource("string:companies_service_delete_confirm", "companies_service_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13434, 64),
      ))
    }

@delegate:ResourceContentHash(1_935_848_232)
internal val Res.string.companies_service_edit: StringResource by lazy {
      StringResource("string:companies_service_edit", "companies_service_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13556, 50),
      ))
    }

@delegate:ResourceContentHash(-631_746_655)
internal val Res.string.companies_service_end: StringResource by lazy {
      StringResource("string:companies_service_end", "companies_service_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13607, 45),
      ))
    }

@delegate:ResourceContentHash(-21_924_255)
internal val Res.string.companies_service_name: StringResource by lazy {
      StringResource("string:companies_service_name", "companies_service_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13653, 54),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.companies_service_save: StringResource by lazy {
      StringResource("string:companies_service_save", "companies_service_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13708, 38),
      ))
    }

@delegate:ResourceContentHash(-389_645_880)
internal val Res.string.companies_service_start: StringResource by lazy {
      StringResource("string:companies_service_start", "companies_service_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13747, 47),
      ))
    }

@delegate:ResourceContentHash(1_191_142_313)
internal val Res.string.companies_service_type: StringResource by lazy {
      StringResource("string:companies_service_type", "companies_service_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13795, 54),
      ))
    }

@delegate:ResourceContentHash(1_322_240_566)
internal val Res.string.companies_services_empty: StringResource by lazy {
      StringResource("string:companies_services_empty", "companies_services_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13850, 72),
      ))
    }

@delegate:ResourceContentHash(-1_544_915_261)
internal val Res.string.companies_services_hide: StringResource by lazy {
      StringResource("string:companies_services_hide", "companies_services_hide", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13923, 55),
      ))
    }

@delegate:ResourceContentHash(1_193_808_767)
internal val Res.string.companies_services_loading: StringResource by lazy {
      StringResource("string:companies_services_loading", "companies_services_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13979, 66),
      ))
    }

@delegate:ResourceContentHash(1_806_076_349)
internal val Res.string.companies_services_show: StringResource by lazy {
      StringResource("string:companies_services_show", "companies_services_show", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14046, 51),
      ))
    }

@delegate:ResourceContentHash(1_326_500_476)
internal val Res.string.companies_title: StringResource by lazy {
      StringResource("string:companies_title", "companies_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14098, 35),
      ))
    }

@delegate:ResourceContentHash(636_528_348)
internal val Res.string.companies_type_eventos: StringResource by lazy {
      StringResource("string:companies_type_eventos", "companies_type_eventos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14134, 42),
      ))
    }

@delegate:ResourceContentHash(1_603_133_491)
internal val Res.string.companies_type_loj: StringResource by lazy {
      StringResource("string:companies_type_loj", "companies_type_loj", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14177, 38),
      ))
    }

@delegate:ResourceContentHash(1_370_073_171)
internal val Res.string.companies_type_tra: StringResource by lazy {
      StringResource("string:companies_type_tra", "companies_type_tra", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14216, 42),
      ))
    }

@delegate:ResourceContentHash(2_646_801)
internal val Res.string.companies_type_upr: StringResource by lazy {
      StringResource("string:companies_type_upr", "companies_type_upr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14259, 30),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.compras_action_cancel: StringResource by lazy {
      StringResource("string:compras_action_cancel", "compras_action_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14290, 41),
      ))
    }

@delegate:ResourceContentHash(1_693_140_584)
internal val Res.string.compras_action_close: StringResource by lazy {
      StringResource("string:compras_action_close", "compras_action_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14332, 36),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.compras_action_delete: StringResource by lazy {
      StringResource("string:compras_action_delete", "compras_action_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14369, 41),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.compras_action_edit: StringResource by lazy {
      StringResource("string:compras_action_edit", "compras_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14411, 35),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.compras_action_save: StringResource by lazy {
      StringResource("string:compras_action_save", "compras_action_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14447, 35),
      ))
    }

@delegate:ResourceContentHash(2_669_562)
internal val Res.string.compras_action_view: StringResource by lazy {
      StringResource("string:compras_action_view", "compras_action_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14483, 31),
      ))
    }

@delegate:ResourceContentHash(965_117_862)
internal val Res.string.compras_actions_menu: StringResource by lazy {
      StringResource("string:compras_actions_menu", "compras_actions_menu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14515, 52),
      ))
    }

@delegate:ResourceContentHash(-1_266_905_744)
internal val Res.string.compras_category_chinese: StringResource by lazy {
      StringResource("string:compras_category_chinese", "compras_category_chinese", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14568, 44),
      ))
    }

@delegate:ResourceContentHash(2_106_068_183)
internal val Res.string.compras_category_cleaning: StringResource by lazy {
      StringResource("string:compras_category_cleaning", "compras_category_cleaning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14613, 45),
      ))
    }

@delegate:ResourceContentHash(1_164_145_288)
internal val Res.string.compras_category_dairy: StringResource by lazy {
      StringResource("string:compras_category_dairy", "compras_category_dairy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14659, 46),
      ))
    }

@delegate:ResourceContentHash(1_223_530_078)
internal val Res.string.compras_category_disposables: StringResource by lazy {
      StringResource("string:compras_category_disposables", "compras_category_disposables", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14706, 56),
      ))
    }

@delegate:ResourceContentHash(697_289_068)
internal val Res.string.compras_category_extras: StringResource by lazy {
      StringResource("string:compras_category_extras", "compras_category_extras", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14763, 39),
      ))
    }

@delegate:ResourceContentHash(234_542_413)
internal val Res.string.compras_category_produce: StringResource by lazy {
      StringResource("string:compras_category_produce", "compras_category_produce", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14803, 48),
      ))
    }

@delegate:ResourceContentHash(-1_430_148_326)
internal val Res.string.compras_category_proteins: StringResource by lazy {
      StringResource("string:compras_category_proteins", "compras_category_proteins", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14852, 49),
      ))
    }

@delegate:ResourceContentHash(195_857_569)
internal val Res.string.compras_category_staples: StringResource by lazy {
      StringResource("string:compras_category_staples", "compras_category_staples", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14902, 44),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.compras_col_actions: StringResource by lazy {
      StringResource("string:compras_col_actions", "compras_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14947, 39),
      ))
    }

@delegate:ResourceContentHash(-87_748_896)
internal val Res.string.compras_col_consumption: StringResource by lazy {
      StringResource("string:compras_col_consumption", "compras_col_consumption", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14987, 43),
      ))
    }

@delegate:ResourceContentHash(-2_017_971_584)
internal val Res.string.compras_col_measurement: StringResource by lazy {
      StringResource("string:compras_col_measurement", "compras_col_measurement", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15031, 43),
      ))
    }

@delegate:ResourceContentHash(-1_849_554_378)
internal val Res.string.compras_col_product: StringResource by lazy {
      StringResource("string:compras_col_product", "compras_col_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15075, 47),
      ))
    }

@delegate:ResourceContentHash(-2_133_127_663)
internal val Res.string.compras_col_total: StringResource by lazy {
      StringResource("string:compras_col_total", "compras_col_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15123, 41),
      ))
    }

@delegate:ResourceContentHash(-1_620_666_033)
internal val Res.string.compras_col_unit_price: StringResource by lazy {
      StringResource("string:compras_col_unit_price", "compras_col_unit_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15165, 54),
      ))
    }

@delegate:ResourceContentHash(-1_335_978_275)
internal val Res.string.compras_entries_title: StringResource by lazy {
      StringResource("string:compras_entries_title", "compras_entries_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15220, 45),
      ))
    }

@delegate:ResourceContentHash(-8_561_233)
internal val Res.string.compras_extra_add_order: StringResource by lazy {
      StringResource("string:compras_extra_add_order", "compras_extra_add_order", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15266, 55),
      ))
    }

@delegate:ResourceContentHash(12_109_021)
internal val Res.string.compras_extra_add_title: StringResource by lazy {
      StringResource("string:compras_extra_add_title", "compras_extra_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15322, 63),
      ))
    }

@delegate:ResourceContentHash(703_199_545)
internal val Res.string.compras_extra_col_delivery_date: StringResource by lazy {
      StringResource("string:compras_extra_col_delivery_date", "compras_extra_col_delivery_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15386, 59),
      ))
    }

@delegate:ResourceContentHash(441_731_364)
internal val Res.string.compras_extra_col_description: StringResource by lazy {
      StringResource("string:compras_extra_col_description", "compras_extra_col_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15446, 53),
      ))
    }

@delegate:ResourceContentHash(-534_600_965)
internal val Res.string.compras_extra_col_order_date: StringResource by lazy {
      StringResource("string:compras_extra_col_order_date", "compras_extra_col_order_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15500, 56),
      ))
    }

@delegate:ResourceContentHash(150_354_718)
internal val Res.string.compras_extra_col_quantity: StringResource by lazy {
      StringResource("string:compras_extra_col_quantity", "compras_extra_col_quantity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15557, 54),
      ))
    }

@delegate:ResourceContentHash(1_949_756_813)
internal val Res.string.compras_extra_col_reason: StringResource by lazy {
      StringResource("string:compras_extra_col_reason", "compras_extra_col_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15612, 40),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.compras_extra_col_unit: StringResource by lazy {
      StringResource("string:compras_extra_col_unit", "compras_extra_col_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15653, 42),
      ))
    }

@delegate:ResourceContentHash(1_462_925_313)
internal val Res.string.compras_extra_delete_message: StringResource by lazy {
      StringResource("string:compras_extra_delete_message", "compras_extra_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15696, 104),
      ))
    }

@delegate:ResourceContentHash(55_315_312)
internal val Res.string.compras_extra_delete_title: StringResource by lazy {
      StringResource("string:compras_extra_delete_title", "compras_extra_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15801, 54),
      ))
    }

@delegate:ResourceContentHash(172_820_937)
internal val Res.string.compras_extra_details_title: StringResource by lazy {
      StringResource("string:compras_extra_details_title", "compras_extra_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15856, 67),
      ))
    }

@delegate:ResourceContentHash(-494_409_967)
internal val Res.string.compras_extra_edit_title: StringResource by lazy {
      StringResource("string:compras_extra_edit_title", "compras_extra_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15924, 60),
      ))
    }

@delegate:ResourceContentHash(-1_911_524_878)
internal val Res.string.compras_extra_import_count: StringResource by lazy {
      StringResource("string:compras_extra_import_count", "compras_extra_import_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15985, 86),
      ))
    }

@delegate:ResourceContentHash(-337_267_571)
internal val Res.string.compras_extra_import_warning: StringResource by lazy {
      StringResource("string:compras_extra_import_warning", "compras_extra_import_warning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16072, 124),
      ))
    }

@delegate:ResourceContentHash(-639_568_597)
internal val Res.string.compras_extra_manage_reasons: StringResource by lazy {
      StringResource("string:compras_extra_manage_reasons", "compras_extra_manage_reasons", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16197, 60),
      ))
    }

@delegate:ResourceContentHash(-2_114_770_634)
internal val Res.string.compras_extra_no_results: StringResource by lazy {
      StringResource("string:compras_extra_no_results", "compras_extra_no_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16258, 68),
      ))
    }

@delegate:ResourceContentHash(-932_659_528)
internal val Res.string.compras_extra_period_empty: StringResource by lazy {
      StringResource("string:compras_extra_period_empty", "compras_extra_period_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16327, 94),
      ))
    }

@delegate:ResourceContentHash(987_420_262)
internal val Res.string.compras_extra_reason_activate: StringResource by lazy {
      StringResource("string:compras_extra_reason_activate", "compras_extra_reason_activate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16422, 49),
      ))
    }

@delegate:ResourceContentHash(-1_616_227_949)
internal val Res.string.compras_extra_reason_active: StringResource by lazy {
      StringResource("string:compras_extra_reason_active", "compras_extra_reason_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16472, 43),
      ))
    }

@delegate:ResourceContentHash(-2_103_102_856)
internal val Res.string.compras_extra_reason_create_title: StringResource by lazy {
      StringResource("string:compras_extra_reason_create_title", "compras_extra_reason_create_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16516, 57),
      ))
    }

@delegate:ResourceContentHash(1_894_488_346)
internal val Res.string.compras_extra_reason_edit_title: StringResource by lazy {
      StringResource("string:compras_extra_reason_edit_title", "compras_extra_reason_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16574, 59),
      ))
    }

@delegate:ResourceContentHash(-497_509_869)
internal val Res.string.compras_extra_reason_inactivate: StringResource by lazy {
      StringResource("string:compras_extra_reason_inactivate", "compras_extra_reason_inactivate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16634, 51),
      ))
    }

@delegate:ResourceContentHash(-497_212_331)
internal val Res.string.compras_extra_reason_inactive: StringResource by lazy {
      StringResource("string:compras_extra_reason_inactive", "compras_extra_reason_inactive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16686, 49),
      ))
    }

@delegate:ResourceContentHash(-1_243_362_202)
internal val Res.string.compras_extra_reason_menu_adjustments: StringResource by lazy {
      StringResource("string:compras_extra_reason_menu_adjustments", "compras_extra_reason_menu_adjustments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16736, 93),
      ))
    }

@delegate:ResourceContentHash(1_949_756_813)
internal val Res.string.compras_extra_reason_name: StringResource by lazy {
      StringResource("string:compras_extra_reason_name", "compras_extra_reason_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16830, 41),
      ))
    }

@delegate:ResourceContentHash(-2_103_102_856)
internal val Res.string.compras_extra_reason_new: StringResource by lazy {
      StringResource("string:compras_extra_reason_new", "compras_extra_reason_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16872, 48),
      ))
    }

@delegate:ResourceContentHash(-136_058_436)
internal val Res.string.compras_extra_reason_none: StringResource by lazy {
      StringResource("string:compras_extra_reason_none", "compras_extra_reason_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16921, 49),
      ))
    }

@delegate:ResourceContentHash(659_047_121)
internal val Res.string.compras_extra_reason_other: StringResource by lazy {
      StringResource("string:compras_extra_reason_other", "compras_extra_reason_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16971, 54),
      ))
    }

@delegate:ResourceContentHash(2_072_417_328)
internal val Res.string.compras_extra_reason_placeholder: StringResource by lazy {
      StringResource("string:compras_extra_reason_placeholder", "compras_extra_reason_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17026, 80),
      ))
    }

@delegate:ResourceContentHash(742_293_422)
internal val Res.string.compras_extra_reason_search: StringResource by lazy {
      StringResource("string:compras_extra_reason_search", "compras_extra_reason_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17107, 55),
      ))
    }

@delegate:ResourceContentHash(440_287_719)
internal val Res.string.compras_extra_reason_stockout: StringResource by lazy {
      StringResource("string:compras_extra_reason_stockout", "compras_extra_reason_stockout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17163, 85),
      ))
    }

@delegate:ResourceContentHash(1_234_142_547)
internal val Res.string.compras_extra_reason_unexpected_demand: StringResource by lazy {
      StringResource("string:compras_extra_reason_unexpected_demand", "compras_extra_reason_unexpected_demand", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17249, 86),
      ))
    }

@delegate:ResourceContentHash(-1_901_704_094)
internal val Res.string.compras_extra_reason_unplanned_events: StringResource by lazy {
      StringResource("string:compras_extra_reason_unplanned_events", "compras_extra_reason_unplanned_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17336, 93),
      ))
    }

@delegate:ResourceContentHash(1_209_078_864)
internal val Res.string.compras_extra_reasons_empty: StringResource by lazy {
      StringResource("string:compras_extra_reasons_empty", "compras_extra_reasons_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17430, 71),
      ))
    }

@delegate:ResourceContentHash(-639_568_597)
internal val Res.string.compras_extra_reasons_title: StringResource by lazy {
      StringResource("string:compras_extra_reasons_title", "compras_extra_reasons_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17502, 59),
      ))
    }

@delegate:ResourceContentHash(-1_352_065_428)
internal val Res.string.compras_extra_saved: StringResource by lazy {
      StringResource("string:compras_extra_saved", "compras_extra_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17562, 79),
      ))
    }

@delegate:ResourceContentHash(1_094_123_852)
internal val Res.string.compras_extra_search_placeholder: StringResource by lazy {
      StringResource("string:compras_extra_search_placeholder", "compras_extra_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17642, 88),
      ))
    }

@delegate:ResourceContentHash(1_790_471_819)
internal val Res.string.compras_extra_units_all_set: StringResource by lazy {
      StringResource("string:compras_extra_units_all_set", "compras_extra_units_all_set", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17731, 83),
      ))
    }

@delegate:ResourceContentHash(1_976_861_733)
internal val Res.string.compras_extra_units_confirm: StringResource by lazy {
      StringResource("string:compras_extra_units_confirm", "compras_extra_units_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17815, 47),
      ))
    }

@delegate:ResourceContentHash(-948_861_862)
internal val Res.string.compras_extra_units_message: StringResource by lazy {
      StringResource("string:compras_extra_units_message", "compras_extra_units_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17863, 163),
      ))
    }

@delegate:ResourceContentHash(880_301_370)
internal val Res.string.compras_extra_units_none: StringResource by lazy {
      StringResource("string:compras_extra_units_none", "compras_extra_units_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18027, 48),
      ))
    }

@delegate:ResourceContentHash(-367_299_751)
internal val Res.string.compras_extra_units_pending: StringResource by lazy {
      StringResource("string:compras_extra_units_pending", "compras_extra_units_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18076, 99),
      ))
    }

@delegate:ResourceContentHash(530_707_849)
internal val Res.string.compras_extra_units_placeholder: StringResource by lazy {
      StringResource("string:compras_extra_units_placeholder", "compras_extra_units_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18176, 79),
      ))
    }

@delegate:ResourceContentHash(1_758_653_228)
internal val Res.string.compras_extra_units_search: StringResource by lazy {
      StringResource("string:compras_extra_units_search", "compras_extra_units_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18256, 54),
      ))
    }

@delegate:ResourceContentHash(5_717_155)
internal val Res.string.compras_extra_units_title: StringResource by lazy {
      StringResource("string:compras_extra_units_title", "compras_extra_units_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18311, 61),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("companies_form_add_title", Res.string.companies_form_add_title)
  map.put("companies_form_edit_title", Res.string.companies_form_edit_title)
  map.put("companies_go_to_org_chart", Res.string.companies_go_to_org_chart)
  map.put("companies_inactive", Res.string.companies_inactive)
  map.put("companies_invalid_number", Res.string.companies_invalid_number)
  map.put("companies_invalid_percent", Res.string.companies_invalid_percent)
  map.put("companies_management_hint", Res.string.companies_management_hint)
  map.put("companies_more_names", Res.string.companies_more_names)
  map.put("companies_none", Res.string.companies_none)
  map.put("companies_only_active", Res.string.companies_only_active)
  map.put("companies_retry", Res.string.companies_retry)
  map.put("companies_save", Res.string.companies_save)
  map.put("companies_search_placeholder", Res.string.companies_search_placeholder)
  map.put("companies_service_add", Res.string.companies_service_add)
  map.put("companies_service_cancel", Res.string.companies_service_cancel)
  map.put("companies_service_daily_quantity", Res.string.companies_service_daily_quantity)
  map.put("companies_service_delete", Res.string.companies_service_delete)
  map.put("companies_service_delete_confirm", Res.string.companies_service_delete_confirm)
  map.put("companies_service_edit", Res.string.companies_service_edit)
  map.put("companies_service_end", Res.string.companies_service_end)
  map.put("companies_service_name", Res.string.companies_service_name)
  map.put("companies_service_save", Res.string.companies_service_save)
  map.put("companies_service_start", Res.string.companies_service_start)
  map.put("companies_service_type", Res.string.companies_service_type)
  map.put("companies_services_empty", Res.string.companies_services_empty)
  map.put("companies_services_hide", Res.string.companies_services_hide)
  map.put("companies_services_loading", Res.string.companies_services_loading)
  map.put("companies_services_show", Res.string.companies_services_show)
  map.put("companies_title", Res.string.companies_title)
  map.put("companies_type_eventos", Res.string.companies_type_eventos)
  map.put("companies_type_loj", Res.string.companies_type_loj)
  map.put("companies_type_tra", Res.string.companies_type_tra)
  map.put("companies_type_upr", Res.string.companies_type_upr)
  map.put("compras_action_cancel", Res.string.compras_action_cancel)
  map.put("compras_action_close", Res.string.compras_action_close)
  map.put("compras_action_delete", Res.string.compras_action_delete)
  map.put("compras_action_edit", Res.string.compras_action_edit)
  map.put("compras_action_save", Res.string.compras_action_save)
  map.put("compras_action_view", Res.string.compras_action_view)
  map.put("compras_actions_menu", Res.string.compras_actions_menu)
  map.put("compras_category_chinese", Res.string.compras_category_chinese)
  map.put("compras_category_cleaning", Res.string.compras_category_cleaning)
  map.put("compras_category_dairy", Res.string.compras_category_dairy)
  map.put("compras_category_disposables", Res.string.compras_category_disposables)
  map.put("compras_category_extras", Res.string.compras_category_extras)
  map.put("compras_category_produce", Res.string.compras_category_produce)
  map.put("compras_category_proteins", Res.string.compras_category_proteins)
  map.put("compras_category_staples", Res.string.compras_category_staples)
  map.put("compras_col_actions", Res.string.compras_col_actions)
  map.put("compras_col_consumption", Res.string.compras_col_consumption)
  map.put("compras_col_measurement", Res.string.compras_col_measurement)
  map.put("compras_col_product", Res.string.compras_col_product)
  map.put("compras_col_total", Res.string.compras_col_total)
  map.put("compras_col_unit_price", Res.string.compras_col_unit_price)
  map.put("compras_entries_title", Res.string.compras_entries_title)
  map.put("compras_extra_add_order", Res.string.compras_extra_add_order)
  map.put("compras_extra_add_title", Res.string.compras_extra_add_title)
  map.put("compras_extra_col_delivery_date", Res.string.compras_extra_col_delivery_date)
  map.put("compras_extra_col_description", Res.string.compras_extra_col_description)
  map.put("compras_extra_col_order_date", Res.string.compras_extra_col_order_date)
  map.put("compras_extra_col_quantity", Res.string.compras_extra_col_quantity)
  map.put("compras_extra_col_reason", Res.string.compras_extra_col_reason)
  map.put("compras_extra_col_unit", Res.string.compras_extra_col_unit)
  map.put("compras_extra_delete_message", Res.string.compras_extra_delete_message)
  map.put("compras_extra_delete_title", Res.string.compras_extra_delete_title)
  map.put("compras_extra_details_title", Res.string.compras_extra_details_title)
  map.put("compras_extra_edit_title", Res.string.compras_extra_edit_title)
  map.put("compras_extra_import_count", Res.string.compras_extra_import_count)
  map.put("compras_extra_import_warning", Res.string.compras_extra_import_warning)
  map.put("compras_extra_manage_reasons", Res.string.compras_extra_manage_reasons)
  map.put("compras_extra_no_results", Res.string.compras_extra_no_results)
  map.put("compras_extra_period_empty", Res.string.compras_extra_period_empty)
  map.put("compras_extra_reason_activate", Res.string.compras_extra_reason_activate)
  map.put("compras_extra_reason_active", Res.string.compras_extra_reason_active)
  map.put("compras_extra_reason_create_title", Res.string.compras_extra_reason_create_title)
  map.put("compras_extra_reason_edit_title", Res.string.compras_extra_reason_edit_title)
  map.put("compras_extra_reason_inactivate", Res.string.compras_extra_reason_inactivate)
  map.put("compras_extra_reason_inactive", Res.string.compras_extra_reason_inactive)
  map.put("compras_extra_reason_menu_adjustments", Res.string.compras_extra_reason_menu_adjustments)
  map.put("compras_extra_reason_name", Res.string.compras_extra_reason_name)
  map.put("compras_extra_reason_new", Res.string.compras_extra_reason_new)
  map.put("compras_extra_reason_none", Res.string.compras_extra_reason_none)
  map.put("compras_extra_reason_other", Res.string.compras_extra_reason_other)
  map.put("compras_extra_reason_placeholder", Res.string.compras_extra_reason_placeholder)
  map.put("compras_extra_reason_search", Res.string.compras_extra_reason_search)
  map.put("compras_extra_reason_stockout", Res.string.compras_extra_reason_stockout)
  map.put("compras_extra_reason_unexpected_demand", Res.string.compras_extra_reason_unexpected_demand)
  map.put("compras_extra_reason_unplanned_events", Res.string.compras_extra_reason_unplanned_events)
  map.put("compras_extra_reasons_empty", Res.string.compras_extra_reasons_empty)
  map.put("compras_extra_reasons_title", Res.string.compras_extra_reasons_title)
  map.put("compras_extra_saved", Res.string.compras_extra_saved)
  map.put("compras_extra_search_placeholder", Res.string.compras_extra_search_placeholder)
  map.put("compras_extra_units_all_set", Res.string.compras_extra_units_all_set)
  map.put("compras_extra_units_confirm", Res.string.compras_extra_units_confirm)
  map.put("compras_extra_units_message", Res.string.compras_extra_units_message)
  map.put("compras_extra_units_none", Res.string.compras_extra_units_none)
  map.put("compras_extra_units_pending", Res.string.compras_extra_units_pending)
  map.put("compras_extra_units_placeholder", Res.string.compras_extra_units_placeholder)
  map.put("compras_extra_units_search", Res.string.compras_extra_units_search)
  map.put("compras_extra_units_title", Res.string.compras_extra_units_title)
}
